import { Combinator } from 'modules/domains/segmentation';

export const QUERY_STUB = {
  field: '',
  value: '',
  comparatorType: '',
};

export const SEARCH_QUERY_STUB = {
  combinator: Combinator.AND,
  searchQueries: [QUERY_STUB],
};
